module.exports = __webpack_public_path__ + "static/media/contacten.e945ad07.png";